
@switch (columnId) {
  @case (PayPalEventDeliveryOrderByEnum.Id) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case (PayPalEventDeliveryOrderByEnum.EventType) {
    <lib-text-table-column>
      {{ element.eventType }}
    </lib-text-table-column>
  }
  @case (PayPalEventDeliveryOrderByEnum.CreateTime) {
    <lib-date-time-label [dateUtc]="element.createTime"></lib-date-time-label>
  }
  @case ('summary') {
    <lib-text-table-column>
      {{ element.summary }}
    </lib-text-table-column>
  }
  @case ('status') {
    <lib-status-chip
      class="paypal-event-statuses"
      [status]="element.status">
    </lib-status-chip>
  }
  @default {
  }
}





